import { type EditorNavSection, EditorSectionNav } from "@/components/EditorSectionNav/EditorSectionNav";

export type ServiceEditorSection = EditorNavSection;

export interface ServiceEditorSectionsViewProps {
  sections: ServiceEditorSection[];
  title: string;
}

/**
 * Presentational section navigation for the service editor index. Renders each
 * editable section (title, tagline, description, photos, pricing) as a
 * navigable tile. The surrounding editor chrome — sidebar header, top bar and
 * mobile navigation — is supplied by `EditFrame` in the container.
 */
export function ServiceEditorSectionsView({ sections, title }: ServiceEditorSectionsViewProps) {
  return <EditorSectionNav ariaLabel={title} sections={sections} />;
}
